import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const PastEpisodesCard = styled.section`
  margin: 16px;
`;

export const MedianCard = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
  border: 1px solid var(--border-soft);
  background-color: var(--surface-default);
  ${borderRadius.r3}
  padding: 16px;
`;

export const PastEpisodesLabel = styled.p`
  ${typographyV2.titleBase}
`;

export const MedianTitle = styled.p`
  ${typographyV2.bodySm}
  color: var(--text-soft);
`;

export const MedianValue = styled.p<{ isPositive: boolean }>`
  font-family: var(--font-roboto-mono);
  ${typographyV2.bodyBase};
  color: ${props =>
    props.isPositive ? 'var(--text-success)' : 'var(--text-critical)'};
`;
